// extracted by mini-css-extract-plugin
export default {"errorText":"l5DC_YqrfdE86Ft_CUh1"};